import axios from "../config/axiosConfig";

const presupuestosService = {
  searchByYear: async (anio) => {
    try {
      const response = await axios.get("/api/presupuestos/search", {
        params: { anio, limit: 10000, orderDir: "ASC" },
      });
      return response.data?.data?.data || [];
    } catch (error) {
      console.error("Error al obtener presupuestos:", error);
      throw error;
    }
  },
};

export default presupuestosService;
